import request from '@/utils/request'

/**
 * 登录接口
 * @param {Object} data - { username, password }
 * @returns {Promise}
 */
export function login(data) {
  return request.post('central/login/account', data)
}

/**
 * 退出登录接口
 * @returns {Promise}
 */
export function logout() {
  return request.post('/user/logout')
}

/**
 * 获取用户信息接口
 * @returns {Promise}
 */
export function getUserInfo() {
  return request.post('/users/get_info_login',{})
}